export const paddingBase = {
    sm: 'p-1',
    md: 'p-sm',
    lg: 'p-3',
};

export const stylesColors = {
    primary: 'focus:border-primary-500',
    variant: 'focus:border-variant-800',
};
